import styled from '@emotion/styled'

export const StyledButtonGroup = styled('div')(({}) => ({
    display: 'flex',
    justifyContent: 'end',
}))
